// components/CommonQuestionsTable.jsx
import React from 'react';

const sampleQuestions = [
  { id: 1, question: 'How do I reset my password?', askedCount: 234, lastAsked: '2024-01-15' },
  { id: 2, question: 'How to update my profile information?', askedCount: 187, lastAsked: '2024-01-14' },
  { id: 3, question: 'What are the payment methods accepted?', askedCount: 156, lastAsked: '2024-01-13' },
  { id: 4, question: 'How to cancel my subscription?', askedCount: 98, lastAsked: '2024-01-12' },
  { id: 5, question: 'How to contact customer support?', askedCount: 76, lastAsked: '2024-01-11' }
];

const CommonQuestionsTable = () => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="dbmm-questions-container">
            <h3 className="dbmm-section-title">Common Questions</h3>
            <div className="dbmm-questions-table-wrapper">
                <table className="dbmm-questions-table">
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Times Asked</th>
                            <th>Last Asked</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sampleQuestions.map(question => (
                            <tr key={question.id}>
                                <td className="dbmm-question-text">{question.question}</td>
                                <td className="dbmm-question-count">{question.askedCount}</td>
                                <td>{formatDate(question.lastAsked)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CommonQuestionsTable;